module.exports = __webpack_public_path__ + "static/our_promise_background-b17cfbd08d64194e4bbfe367c64112ab.png";